export default __webpack_public_path__ + "static/media/ic_weth_24.bc395894.svg";